"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Rotate an element visually
 * @param editor The editor instance
 * @param element The element that should be rotated
 * @param angle The degree at which to rotate the element from it's center
 */
function rotateElement(editor, element, angle) {
    if (element) {
        editor.addUndoSnapshot(function () {
            element.style.transform = "rotate(" + angle + "deg)";
        }, "Format" /* Format */);
    }
}
exports.default = rotateElement;
//# sourceMappingURL=rotateElement.js.map